/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

import { EmailEditor } from 'cio/services/editor';

import AuthService from 'cio/services/auth';
import LayoutModel from 'cio/models/layout';

const TAB_NAME_MAP = {
  wysiwyg: 'Rich text layout',
  html: 'Code layout',
  visual: 'Visual layout',
};

interface PreviewCardArgs {
  item: LayoutModel;
  selectedTab: Exclude<EmailEditor, 'bee'>;
  onPreview: (layout: LayoutModel) => unknown;
  onSelect: (layout: LayoutModel) => unknown;
}

export default class PreviewCard extends Component<PreviewCardArgs> {
  @service auth!: AuthService;

  get selectedTabLabel() {
    return TAB_NAME_MAP[this.args.selectedTab];
  }
}
